import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';


ErrorForm.propTypes = {
  errors: PropTypes.array,
  t: PropTypes.func
};

ErrorForm.defaultProps = {
  errors: []
};

function ErrorForm(props) {
  const {t, errors} = props;
  return (
    <React.Fragment>
      {[...errors].map((key, index) => (
        <div className="form__row form__row--invalid" key={index}>
          <p>{t(key)}</p>
        </div>
      ))}
    </React.Fragment>
  )
}

export default translate('translations')(ErrorForm);



// WEBPACK FOOTER //
// ./src/components/App/ErrorForm.js